export enum StorageKey {
  SIDEBAR = '@gbs-monorepo/sidebar-shrunken',
  UNREAD_NOTIFICATION = '@gbs-monorepo/unread-notification',
}
